import React from 'react';
import shortid from 'shortid';
import ActionableButton from './ActionableButton';
import AirAmbulanceButton from './AirAmbulanceButton/AirAmbulanceButton';
import CallOutToTab from './CallOutToTab';
import EagleEyeVideo from './EagleEyeVideo';
import FallbackComponent from './FallbackComponent';
import FloorSelector from './GeoCommFloorSelector';

/**
 * Normalize the component name to pascal case for component naming convention
 * @param {String} n - the name of the component. words are dash or underscore separated
 */
export const normalizeComponentName = n => {
  if (!n) return '';
  return n
    .split(/[_-]/)
    .map(s => s[0].toUpperCase() + s.slice(1))
    .join()
    .replace(/,/g, '');
};

const Components = {
  AirAmbulanceButton: props => (
    <AirAmbulanceButton key={shortid.generate()} {...props} />
  ),
  CallOutToTab: props => <CallOutToTab key={shortid.generate()} {...props} />,
  FloorSelector: props => <FloorSelector key={shortid.generate()} {...props} />,
  EagleEyeVideo: props => (
    <EagleEyeVideo key={shortid.generate()} data={props.data} />
  ),
  ActionableButton: props => (
    <ActionableButton key={shortid.generate()} {...props} />
  ),
  Default: props => <FallbackComponent key={shortid.generate()} {...props} />,
};

export const getComponentToRender = props => {
  const schema = props.schema;
  const normalizedName = normalizeComponentName(
    schema.componentProperties.name,
  );

  const Component = Components[`${normalizedName}`];
  if (Component) {
    return () => <Component {...props} />;
  }

  // If the corresponding data doesn't contain details for the component,
  // render the fallback component
  return () => <Components.Default {...props} />;
};
